import { CLARITY_GENERATED_BASENAMES, CLARITY_GENERATED_FILE } from './constants/clarity-generated-file.constant';

/** Ported from Clarity `apps/web/src/features/domains/utils/frontmatter.ts` (commit `6750a5f43`). */
/**
 * Whether a Domain file is a **Generated file** — a domain's auto-generated index artifact: a reserved basename
 * (`_concepts.md`, `_relations.md`, `_backlinks.md`), or an `index.md` whose content carries the managed block's
 * opening marker (`frontmatter.ts:28–40`).
 *
 * The name must match exactly. The marker counts only in `index.md`, the one author-editable file that carries an
 * inline managed block, so any other file that merely quotes the marker is not taken for generated — and does not get
 * its body stripped by `stripManagedChrome`.
 *
 * @param name The file's name.
 * @param content The file's raw content, frontmatter included.
 * @returns `true` for a Generated file.
 */
export function isGeneratedFile(name: string, content: string): boolean {
	if (CLARITY_GENERATED_BASENAMES.includes(name)) {
		return true;
	}

	return (
		name === CLARITY_GENERATED_FILE.INDEX_BASENAME &&
		typeof content === 'string' &&
		content.includes(CLARITY_GENERATED_FILE.BEGIN_MARKER)
	);
}
